import type { HelpCenterButtonProps } from "./help-center-button.type";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { HELP_CENTER_URL } from "../help-center.constant";

const HelpCenterButton = ({ short }: HelpCenterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button href={HELP_CENTER_URL} target="_blank">
      {short
        ? t("global:helpCenter.shortButton")
        : t("global:helpCenter.button")}
    </Button>
  );
};

export default HelpCenterButton;
